<script lang="ts">
  import type { Writable } from 'svelte/store'
  import type { EmailSignInFormProps } from './EmailSignInFormProps'
  export let handleChange: (event: Event) => any
  export let key: keyof EmailSignInFormProps
  export let label: string
  export let form: Writable<EmailSignInFormProps>
  export let errors: Writable<Record<keyof EmailSignInFormProps, string>>
  export let password = false
</script>

<label for={key}>{label}</label>
<div class="input-group">
  {#if password}
    <input type="password" id={key} name={key} on:change={handleChange} bind:value={$form[key]} />
  {:else}
    <input type="text" id={key} name={key} on:change={handleChange} bind:value={$form[key]} />
  {/if}
  {#if $errors[key]}
    <small>{$errors[key]}</small>
  {/if}
</div>

<style>
  label {
    grid-column: 1 / span 1;
    text-transform: uppercase;
    font-weight: 600;
    text-align: center;
    align-self: center;
  }

  .input-group {
    grid-column: 2 / span 2;
  }

  input {
    width: 100%;
    display: block;
    border: 1px solid var(--tsf-mid-blue);
    resize: none;
  }

  input:invalid {
    border: 1px solid red;
  }

  small {
    display: block;
  }
</style>
